import { t } from '../utils'
import styles from './_footer.module.scss'

const Copyright: React.FC = () => {
  return (
    <div className={styles.copyright}>
      © {new Date().getFullYear()} {t('Worship Online')}
    </div>
  )
}

export default Copyright
